import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { SquaredTickIcon } from "../../../ui/icons/SquaredTickIcon"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { formatterDate, optionsFormatter, ServiceTypeNormoptions } from "../../../utils"
import { CustomerBillingWorksheetDTO } from "../dataService/dto"
import { GetAllCustomerBillingWorksheet, setAECreationCustomerBWId, setGetAllAECustomerBillingWorksheetId, setGetAllServiceCustomerBillingWorksheetId, setGetAllSTbillingWorksheetId, setServiceCreationCustomerBillingWorksheetId } from "../slice"
import { SchedaCalcoloListEditPopup } from "./editPopup"
import { SchedaCalcoloListViewPopup } from "./viewpopup"

export function SchedaCalcoloCustomerList() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const serviceAndBillingState = useAppSelector(state => state.billingAndServiceType)
    const worksheets = serviceAndBillingState.getAllCustomerBillingWorksheetResponse?.data ?? []
    const [showViewPopup, setShowViewPopup] = useState<boolean>(false)
    const [SCToShow, setSCToShow] = useState<CustomerBillingWorksheetDTO | null>(null)
    const [showEditPopup, setShowEditPopup] = useState<boolean>(false)

    const handleOnEdit = (sc: CustomerBillingWorksheetDTO) => {
        dispatch(setGetAllServiceCustomerBillingWorksheetId(sc.id))
        dispatch(setGetAllAECustomerBillingWorksheetId(sc.id))
        dispatch(setGetAllSTbillingWorksheetId(sc.billingWorksheetId))
        dispatch(setServiceCreationCustomerBillingWorksheetId(sc.id))
        dispatch(setAECreationCustomerBWId(sc.id))
        setShowEditPopup(true)
    }

    useEffect(() => {
        dispatch(GetAllCustomerBillingWorksheet({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }))
    }, [])

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table className="w-full border-collapse text-sm">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl"></th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Anno</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Data Emissione</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Normativa</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Totale Imponibile</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Totale Iva</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Importo Totale</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {worksheets.length === 0 ? (
                        <tr>
                            <td colSpan={8} className="px-3 py-3 text-center text-neutral-500 bg-white">
                                Nessuna scheda di calcolo trovata
                            </td>
                        </tr>
                    ) : (
                        worksheets.map((sc, index) => (
                            <tr
                                key={sc.id ?? index}
                                className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                            >
                                <td className="px-3 py-2 text-neutral-600"></td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                    {sc.year}
                                </td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap text-xs">
                                    {formatterDate(sc.createdAt)}
                                </td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                    {optionsFormatter(sc.norm, ServiceTypeNormoptions)}
                                </td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                    €{sc.totalTaxableFee}
                                </td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                    €{sc.totalIva}
                                </td>
                                <td className="px-3 py-2 text-center text-neutral-700 whitespace-nowrap">
                                    €{sc.totalFee}
                                </td>
                                <td className="px-3 py-2 w-[60px]">
                                    <div className="flex items-center justify-center gap-2">
                                        <button
                                            className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                            onClick={() => {
                                                setSCToShow(sc)
                                                setShowViewPopup(true)
                                            }}
                                        >
                                            <SquaredTickIcon />
                                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                Dettaglio Scheda
                                            </span>
                                        </button>
                                        <button
                                            className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                            onClick={() => {
                                                handleOnEdit(sc)
                                            }}
                                        >
                                            <EditIcon color="orange" size={20} />
                                            <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                Modifica Scheda
                                            </span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            {(showViewPopup && SCToShow) && (
                <PopupForm width title={`Dettaglio Scheda di Calcolo`} headerGreen close={() => setShowViewPopup(false)}>
                    <SchedaCalcoloListViewPopup customerBilling={SCToShow} close={() => setShowViewPopup(false)} />
                </PopupForm>
            )}
            {showEditPopup && (
                <PopupForm width title={`Modifica Scheda di Calcolo`} headerGreen close={() => setShowEditPopup(false)}>
                    <SchedaCalcoloListEditPopup close={() => setShowEditPopup(false)} />
                </PopupForm>
            )}
        </div>
    )
}